import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const User = createSvgIcon(
  () => (
    <path d="M21.875 25C28.7109 25 34.375 19.4336 34.375 12.5C34.375 5.66406 28.7109 0 21.875 0C14.9414 0 9.375 5.66406 9.375 12.5C9.375 19.4336 14.9414 25 21.875 25ZM30.5664 28.125H28.9062C26.7578 29.1992 24.4141 29.6875 21.875 29.6875C19.3359 29.6875 16.8945 29.1992 14.7461 28.125H13.0859C5.85938 28.125 0 34.082 0 41.3086V45.3125C0 47.9492 2.05078 50 4.6875 50H39.0625C41.6016 50 43.75 47.9492 43.75 45.3125V41.3086C43.75 34.082 37.793 28.125 30.5664 28.125Z" />
  ),
  '0 0 44 50'
);
